<template>
	<div v-loading="loading" class="template-library">
		<lcsj-filter :show-search="false">
			<el-form-item label="模板："><el-input v-model="search" size="small" placeholder="名称或编码" clearable /></el-form-item>
			<el-form-item label="状态："><el-select v-model="status" size="small" clearable placeholder="全部状态">
				<el-option label="已发布" value="published" />
				<el-option label="有未发布修改" value="draft" />
				<el-option label="已停用" value="disabled" />
			</el-select></el-form-item>
			<template #actions>
			<el-button icon="el-icon-refresh" @click="load">刷新</el-button>
			<el-button v-if="canEdit" type="primary" icon="el-icon-plus" @click="$refs.editor.open()">新增模板</el-button>
			</template>
		</lcsj-filter>
		<el-table :data="filtered" border class="lcsj-data-table">
			<el-table-column label="模板名称" min-width="180">
				<template #default="s">
					{{ s.row.template.name }}
					<el-tag v-if="s.row.template.isDefault" size="mini">默认</el-tag>
				</template>
			</el-table-column>
			<el-table-column prop="template.code" label="模板编码" min-width="130" />
			<el-table-column prop="itemCount" label="组件数" width="80" align="center" />
			<el-table-column label="状态" width="160">
				<template #default="s">
					<el-tag :type="!s.row.template.enabled ? 'info' : s.row.template.publishedVersionKeyId ? 'success' : 'warning'" size="small">
						{{ !s.row.template.enabled ? "已停用" : s.row.template.publishedVersionKeyId ? "已发布" : "草稿" }}
					</el-tag>
					<div v-if="s.row.template.draftVersionKeyId !== s.row.template.publishedVersionKeyId" class="hint">有未发布修改</div>
				</template>
			</el-table-column>
			<el-table-column label="关联角色" min-width="160">
				<template #default="s">{{ s.row.roles.join("、") || "—" }}</template>
			</el-table-column>
			<el-table-column prop="template.updateTime" label="更新时间" width="200" />
			<el-table-column label="操作" width="290">
				<template #default="s">
					<el-button type="text" @click="$refs.editor.open(s.row)">{{ canEdit ? "配置布局" : "查看布局" }}</el-button>
					<el-button type="text" :disabled="!s.row.template.publishedVersionKeyId" @click="preview(s.row)">预览发布版</el-button>
					<el-dropdown v-if="canEdit || canPublish" @command="command($event, s.row)">
						<el-button type="text">
							更多
							<i class="el-icon-arrow-down" />
						</el-button>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-if="canEdit" command="copy">复制模板</el-dropdown-item>
							<el-dropdown-item v-if="canPublish" command="default" :disabled="!!s.row.template.isDefault || !s.row.template.publishedVersionKeyId || !s.row.template.enabled">
								设为默认
							</el-dropdown-item>
							<el-dropdown-item v-if="canEdit" :command="s.row.template.enabled ? 'disable' : 'enable'">{{ s.row.template.enabled ? "停用" : "启用" }}</el-dropdown-item>
							<el-dropdown-item v-if="canEdit" command="delete">删除</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</template>
			</el-table-column>
		</el-table>
		<p class="hint">保存草稿不影响首页；发布后对关联角色生效。角色未指定模板时展示原默认工作台，默认标记不会自动分配给角色。</p>
		<home-layout-editor ref="editor" :permissions="permissions" @saved="load" />
		<home-preview ref="preview" />
	</div>
</template>
<script>
import { homePageRequest as api } from "@/api/homePageApi";
import HomeLayoutEditor from "./homeLayoutEditor.vue";
import HomePreview from "./homePreview.vue";
export default {
	components: { HomeLayoutEditor, HomePreview },
	props: { permissions: Array },
	data: () => ({ loading: false, rows: [], search: "", status: "" }),
	computed: {
		canEdit() {
			return this.permissions.includes("homeTemplateEdit");
		},
		canPublish() {
			return this.permissions.includes("homeTemplatePublish");
		},
		filtered() {
			return this.rows.filter((r) => {
				const t = r.template;
				return (
					(t.name.includes(this.search) || t.code.includes(this.search)) &&
					(!this.status ||
						(this.status === "published" && t.enabled && t.publishedVersionKeyId) ||
						(this.status === "draft" && t.draftVersionKeyId !== t.publishedVersionKeyId) ||
						(this.status === "disabled" && !t.enabled))
				);
			});
		}
	},
	created() {
		this.load();
	},
	methods: {
		async load() {
			this.loading = true;
			try {
				this.rows = await api("Templates");
			} catch (e) {
				this.$message.error(e.message);
			} finally {
				this.loading = false;
			}
		},
		async preview(row) {
			try {
				const d = await api("Detail", { keyId: row.template.keyId, action: "published" });
				this.$refs.preview.open(d.template.name, d.items);
			} catch (e) {
				this.$message.error(e.message);
			}
		},
		async command(action, row) {
			if (action === "copy") return this.$refs.editor.open(row, true);
			try {
				await this.$confirm(`确定${{ default: "设为默认", enable: "启用", disable: "停用", delete: "删除" }[action]}“${row.template.name}”？`, "模板维护");
			} catch (_) {
				return;
			}
			this.loading = true;
			try {
				await api("TemplateAction", { keyId: row.template.keyId, revision: row.template.revision, action });
				this.$message.success("操作成功");
				await this.load();
			} catch (e) {
				this.$message.error(e.message);
			} finally {
				this.loading = false;
			}
		}
	}
};
</script>
<style scoped>
.toolbar {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 12px;
	margin: 12px 0 20px;
}
.toolbar .el-input {
	width: 240px;
}
.toolbar .el-select {
	width: 170px;
}
.hint {
	color: var(--app-text-secondary);
	font-size: 12px;
	line-height: 24px;
}
.el-dropdown {
	margin-left: 12px;
}
</style>
